import React, { useEffect } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CheckoutSteps from "../../Components/CheckoutSteps";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../../store/actions/orderAction";
import { ORDER_CREATE_RESET } from "../../constants/orderConstants";
import LoadingBox from "../../Components/Loader";
import MessageBox from "../../Components/MessageBox";
import {useNavigate} from 'react-router-dom'
function PlaceOrderScreen(props) {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const orderCreate = useSelector((state) => state.orderCreate);
  const { loading, error, success, order } = orderCreate;
  const dispatch = useDispatch();
  const { cartItems } = cart;
  if (!cart.paymentMethod) {
    navigate("/payment");
  }

  const orderSubmitHandler = () => {
    dispatch(
      createOrder({
        ...cart,
        orderItems: cart.cartItems,
      })
    );
  };

  const toPrice = (num) => Number(num.toFixed(2));
  cart.itemsPrice = toPrice(
    cart.cartItems.reduce((a, c) => a + c.qty * c.price, 0)
  );
  cart.shippingPrice = cart.itemsPrice > 100 ? toPrice(0) : toPrice(10);
  cart.taxPrice = toPrice(0.15 * cart.itemsPrice);
  cart.totalPrice = cart.itemsPrice + cart.taxPrice + cart.shippingPrice;

  useEffect(() => {
    if (success) {
      navigate(`/order/${order._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
    }

    if(cartItems.length===0){
      navigate('/orderhistory')
    }
  }, [dispatch, order, success,navigate,cartItems]);
  
  return (
    <div className="placeOrderContainer">
      <CheckoutSteps step1 step2 step3 step4 />
      <Container className="my-5">
        <Row>
          <Col xs={12} md={8} className="">
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button collapsed bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    Shipping
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="accordion-body">
                    <div>
                      <span className="fs1 font-weight-bolder">Name: </span>
                      <span>{cart.shippingAddress.fullName}</span>
                    </div>
                    <div>
                      <span className="fs1 font-weight-bolder">Address: </span>
                      <span>{cart.shippingAddress.address}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    className="accordion-button collapsed bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Payment
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div className="accordion-body">
                    <span className="fs1 font-weight-bolder">Method: </span>
                    <span>{cart.paymentMethod}</span>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingThree"
                >
                  <button
                    className="accordion-button bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTheree"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseTheree"
                  >
                    Order Items
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTheree"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingTheree"
                >
                  <div className="accordion-body">
                    {cartItems.map((item, i) => {
                      return (
                        <Row key={i} className="my-3 align-items-center">
                          <Col xs={4} md={4}>
                            <img
                              width="80px"
                              src={item.image.map((img, i) => img.coverimg)}
                              alt="img"
                            />
                          </Col>
                          <Col xs={4} md={4}>
                            {item.name}
                          </Col>
                          <Col xs={4} md={4}>
                            {item.qty} x {item.price} = ${" "}
                            {item.qty * item.price}
                          </Col>
                        </Row>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <Card>
              <Card.Header className="text-center bg-warning" as="h5">
                Order Summary
              </Card.Header>
              <Card.Body>
                <div>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Items</span>
                    <span>{"$" + cart.itemsPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Shipping</span>
                    <span>{"$" + cart.shippingPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Tax</span>
                    <span>{"$" + cart.taxPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <h5>Order Total</h5>
                    <span>{"$" + cart.totalPrice.toFixed(2)}</span>
                  </span>
                </div>
                <Button
                  type="submit"
                  variant="outline-warning"
                  className="w-100 fs1"
                  disabled={cart.cartItems.length === 0}
                  onClick={orderSubmitHandler}
                >
                  Place Order
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {loading && <LoadingBox></LoadingBox>}
        {error && <MessageBox variant="danger">{error}</MessageBox>}
      </Container>
    </div>
  );
}

export default PlaceOrderScreen;
